import React from 'react'
import Style from './Divider.module.css'
const Divider = () => {
    return (
        <div className={Style.divider}><span></span><span className={Style.textHolder}>ElectronicSteps</span><span></span></div>
    )
}

export default Divider
